import { __spreadArray } from "tslib";
var Logger = /** @class */ (function () {
    function Logger() {
        this.debugMode = false;
        this.prefix = '[dreamdata-analytics]:';
        this.debugMode = Boolean(localStorage.getItem('DD_AUTO_IDENTIFY_DEBUG_MODE'));
        if (this.debugMode) {
            this.info('Debugger enabled');
        }
    }
    Logger.prototype.debug = function () {
        var message = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            message[_i] = arguments[_i];
        }
        if (!this.debugMode) {
            return;
        }
        console.debug.apply(console, __spreadArray([this.prefix], message, false));
    };
    Logger.prototype.debugError = function (message) {
        if (!this.debugMode) {
            return;
        }
        this.error(message);
    };
    Logger.prototype.error = function (message) {
        console.error("%c".concat(this.prefix, " ").concat(message), 'font-weight: bold;');
    };
    Logger.prototype.info = function (message) {
        console.info(this.prefix, message);
    };
    return Logger;
}());
export var logger = new Logger();
//# sourceMappingURL=logger.js.map